import { Community, Market, User } from '.';

export class WeeklyReportParams {
    market: Market;
    communities: Community[];
    timeFrame: string;
    phaseReleases: string[];
    fieldManagers: User[];
    fileFormat: string;
}
